import axios from "axios";
import React, { Fragment } from "react";
import { Navigate } from "react-router-dom";
import mainLogo from "../mglogo.png";
import "react-toastify/dist/ReactToastify.css";
import { toast } from 'react-toastify';
import MemberpayListCashFreeView from "./MemberpayListCashFreeView";
import { Dialog, Transition } from "@headlessui/react";
import { PaginationLinks } from "./helper";
import { env } from "./env";

const loadScript = (src) => {
    return new Promise((resolve) => {
        const script = document.createElement("script");
        script.src = src;
        script.onload = () => {
            resolve(true);
        };
        script.onerror = () => {
            resolve(false);
        };
        document.body.appendChild(script);
    });
};


const COMPONENTDIDMOUNT = 'component_did_mount'
const RAZORPAY_SCRIPT_FAILURE = 'razorpay_script_failure'

class MemberpayList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            primary_member_status: null,
            sidebarOpen: false,
            setSidebarOpen: false,
            showmsg: false,
            redirect: false,
            deleteRedirect: false,
            logoutRedirect: false,
            invoices_member: [],
            order_id_from_server: '',
            invoice_id: '',
            cryptKey: "",
            links: [],
            Minidash: [],
            totalnoof: "",
            perpage: "",
            from: "",
            to: "",
            loader: "",
            overLay: "",
            critical_error: "Critical Error Contact Admin",
            try_again_name: '',
            error_customize: "Network Failed",
            critical_error_status: false,
            editId: "",
            customer_modal_open_for_view: false,
            payment_success: false,
            loader_status: false,
            try_again_status: false,
            main_content_status: false,
        };
    }


    setLoaderFunction = () => {

        this.setState({
            loader_status: true,
            try_again_status: false,
            main_content_status: false,
        });
    };
    closeLoaderFuncion = () => {
        this.setState({
            loader_status: false,
            try_again_status: false,
            main_content_status: true,
        });
    };

    enableTryAgain = () => {

        this.setState({
            loader_status: false,
            try_again_status: true,
            main_content_status: false,
        });
    };

    enableCriticalError = () => {

        this.setState({
            loader_status: false,
            try_again_status: false,
            main_content_status: false,
            critical_error_status: true,
        });
    };

    view = (e) => {
        this.setState({ customer_modal_open_for_view: true });
        this.setState({ editId: e });
    };

    closeMemberpayView = () => {
        this.setState({ customer_modal_open_for_view: false });
    };


    close = async (e) => {
        this.setState({ sidebarOpen: false });
    };
    open = async (e) => {
        this.setState({ sidebarOpen: true });
    };

    delete = async (e) => {
        this.setState({ deletealartmsg: true });
        this.setState({ cryptKey: e });
    };

    componentDidMount() {
        this.getData();
    }



    tryAgain = () => {

        this.getData()
        switch (this.state.try_again_name) {
            case COMPONENTDIDMOUNT:
              this.getData();
              break;
            case RAZORPAY_SCRIPT_FAILURE:
              this.razorpaypayment();
              break;
          }
    }




    async getData() {
        try {
            this.setLoaderFunction()
            const token = localStorage.getItem("token");
            const [
                { data: member },
                { data: dashboard },

            ] = await Promise.all([
                axios.get("api/invoice/pagination/member", { headers: { authorization: `Bearer ${token}`, Accept: "application/json" } }),
                axios.get("api/member/dashboard", { headers: { authorization: `Bearer ${token}`, Accept: "application/json" } }),
            ]);
            const invoices1 = member.invoices_member.data;
            this.state.primary_member_status = member.memberDetail;
            let link = member.invoices_member.links;

            this.setState({ invoices_member: invoices1 });
            this.setState({ loader: "" });
            this.setState({ links: link });
            this.setState({ perpage: member.invoices_member.per_page });
            this.setState({ totalnoof: member.invoices_member.total });
            this.setState({ from: member.invoices_member.from });
            this.setState({ to: member.invoices_member.to });

            this.setState({ Minidash: dashboard.one });
            this.closeLoaderFuncion();

        } catch (error) {
            console.error("Error fetching data: ", error);
            this.state.try_again_name = COMPONENTDIDMOUNT;
            this.enableTryAgain()
        }
    }




    handle_response = (e) => {
        this.setState({ payment_success: true });
    }

    componentDidUpdate() {

        if (this.state.payment_success) {

            this.setLoaderFunction();
            const token = localStorage.getItem("token");
            const res = axios
                .get("api/invoice/pagination/member", {
                    headers: {
                        authorization: `Bearer ${token}`,
                        Accept: "application/json",
                    },
                })
                .then((res) => {

                    const invoices1 = res.data.invoices_member.data;
                    this.state.primary_member_status = res.data.memberDetail;
                    let link = res.data.invoices_member.links;

                    this.setState({ invoices_member: invoices1 });
                    this.setState({ loader: "" });
                    this.setState({ links: link });
                    this.setState({ perpage: res.data.invoices_member.per_page });
                    this.setState({ totalnoof: res.data.invoices_member.total });
                    this.setState({ from: res.data.invoices_member.from });
                    this.setState({ to: res.data.invoices_member.to });
                });
            this.setState({ payment_success: false });
            this.closeLoaderFuncion();
        }

    }

    Search = (e) => {
        this.setLoaderFunction();
        this.state.invoices_member = [];
        const token = localStorage.getItem("token");
        const search = e.target.value;
        const res = axios
            .get("api/invoice/pagination/member?search_v=" + search, {
                headers: {
                    authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
            })
            .then((res) => {
                const invoices_member = res.data.invoices_member.data;
                let link = res.data.invoices_member.links;
                this.setState({ invoices_member: invoices_member });
                this.setState({ loader: "" });
                this.setState({ links: link });
                this.setState({ perpage: res.data.invoices_member.per_page });
                this.setState({ totalnoof: res.data.invoices_member.total });
                this.setState({ from: res.data.invoices_member.from });
                this.setState({ to: res.data.invoices_member.to });
            });
        this.closeLoaderFuncion();
    };

    addinvoice = (e) => {
        this.setState({ redirect: true });
    };


    paginationFetch = async (e) => {
        if (e) {
            this.state.invoices_member = [];
            this.setLoaderFunction(true, true);
            const token = localStorage.getItem("token");
            const res = axios
                .get(e, {
                    headers: {
                        authorization: `Bearer ${token}`,
                        Accept: "application/json",
                    },
                })
                .then((res) => {
                    const invoices_member = res.data.invoices_member.data;
                    let link = res.data.invoices_member.links;
                    this.setState({ invoices_member: invoices_member });
                    this.setState({ loader: "" });
                    this.setState({ links: link });
                    this.setState({ perpage: res.data.invoices_member.per_page });
                    this.setState({ totalnoof: res.data.invoices_member.total });
                    this.setState({ from: res.data.invoices_member.from });
                    this.setState({ to: res.data.invoices_member.to });
                    this.closeLoaderFuncion();
                });

        }
    };

    razorpaypayment = (index) => async (e) => {
        e.preventDefault();

        const token = localStorage.getItem("token");
        const invoiceID = index;
        this.state.invoice_id = invoiceID;

        this.setState({ invoice_id: this.state.invoice_id });
        const headers = {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
        };

        this.setLoaderFunction();

        try {
            const res1 = await axios.post("api/member/pay", this.state, { headers });

            if (res1.data.success) {
                this.setState({ order_id_from_server: res1.data.invoice.razorpay_payment.order_id });
                const res = await loadScript("https://checkout.razorpay.com/v1/checkout.js");

                var hr = this;
                const options = {
                    key:(env.key),
                    name: "ARWA",
                    description: "Payment",
                    image: { mainLogo },
                    order_id: this.state.order_id_from_server,
                    handler: async function (response) {
                        const data = {
                            razorpay_payment_id: response.razorpay_payment_id,
                            razorpay_order_id: response.razorpay_order_id,
                            razorpay_signature: response.razorpay_signature,
                            http_status_code: 200,
                        };

                        const result = await axios.post("/api/razorpay/payment/store", data, { headers });
                        toast.success(result.data.message);
                        hr.handle_response(response);
                    },
                    prefill: {
                        name: this.state.invoices_member[0].primary_member?.primary_contact_first_name,
                        email: this.state.invoices_member[0].primary_member?.customer_email,
                        contact: this.state.invoices_member[0].primary_member?.customer_mobile
                    },
                    notes: {
                        address: "",
                    },
                    theme: {
                        color: "#61dafb",
                    },
                };
                console.log(options)

                const paymentObject = new window.Razorpay(options);
                paymentObject.open();
                this.closeLoaderFuncion();
            } else {
                if (res1.data.hasOwnProperty('controller_error') && res1.data.controller_error) {
                    this.enableCriticalError();
                } else {
                    this.setState({ error_list: res1.data.data });
                }
            }
        } catch (error) {
            console.error('Failed to load Razorpay script', error);
            this.state.try_again_name = RAZORPAY_SCRIPT_FAILURE;
            this.enableTryAgain();
        } 
    };




    render() {
        let token = localStorage.getItem("token");

        if (this.state.deleteRedirect) {
            window.location.reload();
        } else {
        }
        if (token == null) {
            return <Navigate to={"/Login"} />;
        }
        if (this.state.logoutRedirect) {
            return <Navigate to={"/Login"} />;
        }

        if (this.state.redirect) {
            return <Navigate to={"/filterby/invoice"} />;
        }


        return (
            <>
                <div>
                    <div className={this.state.overLay} aria-hidden="true" />
                    {/* Static sidebar for desktop */}

                    {this.state.loader_status && (
                        <div className="h-screen flex items-center justify-center bg-white bg-opacity-50 z-50">
                            <div className="bg-white p-4 rounded-md">
                                <div className="flex items-center justify-center">
                                    <div
                                        className="animate-spin rounded-full border-4 border-l-blue-500 border-r-blue-500 border-t-blue-500 border-white-300 h-12 w-12"></div>
                                </div>
                                <p className="text-center mt-4">Loading...</p>
                            </div>
                        </div>
                    )}
                    {/*loader_status------------------------------------------------------------------------*/}

                    {/*try_again_status-----------------------------------------------------------------------------*/}
                    {this.state.try_again_status && (
                        <div className="h-screen flex items-center justify-center bg-white ">
                            <div className="flex flex-col items-center justify-center h-full">
                                <p className="text-red-500">{this.state.error_customize}</p>
                                <button
                                    type="button"
                                    onClick={this.tryAgain}
                                    className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                                    TryAgain
                                </button>
                            </div>
                        </div>
                    )}
                    {/*try_again_status-----------------------------------------------------------------------------*/}

                    {this.state.critical_error_status && (
                        <div className="fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center bg-gray-800 bg-opacity-75 z-50">
                            <div className="animate-fadeInDown bg-white p-8 rounded-lg shadow-lg text-center">
                                <svg
                                    className="h-16 w-16 text-red-500 mb-4"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                                <p className="text-red-500 mb-4 font-semibold">{this.state.critical_error}</p>
                            </div>
                        </div>
                    )}

                    <div className="flex flex-col flex-1">
                        {this.state.main_content_status && (

                            <main className="flex-1">
                                <div className="py-6">
                                    <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                                        <div>
                                            <dl className="mt-5 grid grid-cols-1 rounded-lg bg-white overflow-hidden shadow divide-y divide-gray-200 md:grid-cols-3 md:divide-y-0 md:divide-x">
                                                {this.state.Minidash.map((item) => (
                                                    <div key={item.id} className="px-4 py-5 sm:p-6">
                                                        <dt className="text-base font-normal text-gray-900">
                                                            {item.name}
                                                        </dt>
                                                        <dd className="mt-1 flex justify-between items-baseline md:block lg:flex">
                                                            <div
                                                                className="flex items-baseline text-2xl font-semibold text-indigo-600">
                                                                {item.stat}
                                                            </div>
                                                        </dd>
                                                    </div>
                                                ))}
                                            </dl>
                                        </div>

                                        {/* Replace with your content */}
                                        <div className="px-4 sm:px-6 lg:px-8 mt-6">
                                            <div className="sm:flex sm:items-center">
                                                <div className="sm:flex-auto">
                                                    <h1 className="text-xl font-semibold text-gray-900">
                                                        Dues List
                                                    </h1>
                                                    <p className="mt-2 text-sm text-gray-700">
                                                        A list of all the dues
                                                    </p>
                                                </div>

                                            </div>
                                            <div className="mt-8 flex flex-col">
                                                <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                                    <div
                                                        className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                                                        <div
                                                            className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
                                                            <table
                                                                className={`min-w-full divide-y divide-gray-300 ${this.state.loader}`}
                                                            >
                                                                <thead className="bg-gray-50">
                                                                    <tr>
                                                                        <th
                                                                            scope="col"
                                                                            className="py-3 pl-4 pr-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500 sm:pl-6"
                                                                        >
                                                                            Date
                                                                        </th>
                                                                        <th
                                                                            scope="col"
                                                                            className="px-3 py-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500"
                                                                        >
                                                                            Due#
                                                                        </th>
                                                                        <th
                                                                            scope="col"
                                                                            className="px-3 py-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500"
                                                                        >
                                                                            House Number
                                                                        </th>

                                                                        <th
                                                                            scope="col"
                                                                            className="px-3 py-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500"
                                                                        >
                                                                            Member Name
                                                                        </th>

                                                                        <th
                                                                            scope="col"
                                                                            className="px-3 py-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500"
                                                                        >
                                                                            Amount
                                                                        </th>
                                                                        <th
                                                                            scope="col"
                                                                            className="px-3 py-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500"
                                                                        >
                                                                            Status
                                                                        </th>
                                                                        <th
                                                                            scope="col"
                                                                            className="px-3 py-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500"
                                                                        >
                                                                            Balance Due
                                                                        </th>
                                                                        <th
                                                                            scope="col"
                                                                            className="px-3 py-3 text-center text-xs font-medium uppercase tracking-wide text-gray-500"
                                                                        >
                                                                            Action
                                                                        </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody className="divide-y divide-gray-200 bg-white">
                                                                    {this.state.invoices_member.map((person) => (
                                                                        <tr key={person.id}>
                                                                            <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                                                                {person.invoice_date}
                                                                            </td>
                                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                                                {person.invoice_number}
                                                                            </td>
                                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                                                {
                                                                                    person.invoice_house.house_number
                                                                                }
                                                                            </td>
                                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                                                {
                                                                                    person.primary_member?.primary_contact_first_name
                                                                                } {
                                                                                    person.primary_member?.primary_contact_last_name
                                                                                }
                                                                            </td>


                                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                                                {person.invoice_state?.id === 5 ? '0.00' : person.invoice_total}
                                                                            </td>


                                                                            <td className={`whitespace-nowrap px-3 py-4 text-sm
                                                                        ${person.invoice_state?.id === 2 ? 'text-green-500' :
                                                                                    person.invoice_state?.id === 5 ? 'text-yellow-500' : person.invoice_state?.id === 6 ? 'text-blue-500' :
                                                                                        (person.invoice_state?.id === 4 ? 'text-red-500' : 'text-gray-500')}`}>
                                                                                {person.invoice_state?.name}
                                                                            </td>


                                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                                                                {person.invoice_state?.id === 5 ? '0.00' : person.invoice_balance_due}
                                                                            </td>



                                                                            <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-center text-sm font-medium sm:pr-6">

                                                                                {<span
                                                                                    onClick={() =>
                                                                                        this.view(person.id_crypt)
                                                                                    }
                                                                                    className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 cursor-pointer">
                                                                                    View</span>}

                                                                                {((person.invoice_state_id !== 2) && (this.state.primary_member_status?.customer_primary_contact_status !== 0)) ?
                                                                                    person.invoice_state_id === 5 ? (
                                                                                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800 ">
                                                                                            Vacant
                                                                                        </span>
                                                                                    ) : (
                                                                                        <span
                                                                                            onClick={this.razorpaypayment(person.id)}
                                                                                            className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800 cursor-pointer">
                                                                                            Pay
                                                                                        </span>
                                                                                    ) : (
                                                                                        person.invoice_state_id === 2 ? (
                                                                                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 ">
                                                                                                Paid
                                                                                            </span>
                                                                                        ) : null
                                                                                    )}

                                                                            </td>


                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                            {/*pagination*/}

                                                            {/*part_three_pagination_links----------------------------------------------------------------------------------------------*/}
                                                            <PaginationLinks
                                                                from={this.state.from}
                                                                to={this.state.to}
                                                                total_no_of_item={this.state.total_no_of_project}
                                                                links={this.state.links}
                                                                paginationFetch={this.paginationFetch}
                                                            />
                                                            {/*part_three_pagination_links----------------------------------------------------------------------------------------------*/}

                                                            {/*pagination*/}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        {/* /End replace */}
                                    </div>
                                </div>
                            </main>
                        )}
                    </div>

                    {/** Modal View */}
                    <Transition.Root
                        show={this.state.customer_modal_open_for_view}
                        as={Fragment}
                    >
                        <Dialog
                            as="div"
                            className="relative z-10"
                            onClose={this.closeMemberpayView}
                        >
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0"
                                enterTo="opacity-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100"
                                leaveTo="opacity-0"
                            >
                                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                            </Transition.Child>

                            <div className="fixed z-10 inset-0 overflow-y-auto">
                                <div
                                    className="flex items-end lg:items-center  justify-center min-h-full p-4 text-center sm:p-0">
                                    <Transition.Child
                                        as={Fragment}
                                        enter="ease-out duration-300"
                                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                                        leave="ease-in duration-200"
                                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                    >
                                        <Dialog.Panel
                                            className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8  md:max-w-screen-md lg:max-w-screen-lg sm:w-full sm:p-6">
                                            <div>
                                                <MemberpayListCashFreeView
                                                    memberId={this.state.editId}

                                                />
                                            </div>
                                        </Dialog.Panel>
                                    </Transition.Child>
                                </div>
                            </div>
                        </Dialog>
                    </Transition.Root>
                    {/** Modal View*/}
                </div>


            </>
        );
    }
}

export default MemberpayList;
